import { render, staticRenderFns } from "./DataTableAssignUsers.vue?vue&type=template&id=0b90a8fc&scoped=true&"
import script from "./DataTableAssignUsers.vue?vue&type=script&lang=js&"
export * from "./DataTableAssignUsers.vue?vue&type=script&lang=js&"
import style0 from "./DataTableAssignUsers.vue?vue&type=style&index=0&id=0b90a8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b90a8fc",
  null
  
)

export default component.exports